if (!customElements.get('site-traceability')) {
  customElements.define(
    'site-traceability',
    class SiteTraceability extends HTMLElement {
      constructor() {
        super();

        /**
         * Elements object to store all selectors
         */
        this.elements = {
          toggleElement: '[data-toggle-tier]',
          toggleContainer: '[data-toggle-container]',
          toggleTarget: '[data-toggle-sublist]',
        };

        /**
         * Find all elements with data-toggle-tier attribute
         * and add click event listener
         */
        this.toggleElement = this.querySelectorAll(this.elements.toggleElement).forEach((item) => {
          item.addEventListener('click', this.onTierClick);
        });
      }

      /**
       *
       * @param {*} event
       * find click target and toggle active class and hidden class
       */
      onTierClick = (event) => {
        const toggleContainer = event.target.closest(this.elements.toggleContainer);
        const toggleTarget = toggleContainer.querySelector(this.elements.toggleTarget);

        if (toggleTarget) {
          toggleContainer.classList.toggle('active');
          toggleTarget.classList.toggle('hidden');
        }
      };
    }
  );
}
